import React, { useState, useEffect } from "react";
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { RFValue } from "react-native-responsive-fontsize";
import Config from "../../Config";
import { Video } from "expo-av";

const Examvideo = (props) => {
    // استیت برای ذخیره پاسخی که کاربر انتخاب کرده
    const [selectedAnswer, setSelectedAnswer] = useState(null);
    // استیت برای قفل کردن دکمه‌ها بعد از کلیک اول
    const [isLocked, setIsLocked] = useState(false);

    // هر بار که سوال عوض شد، استیت‌ها ریست شوند
    useEffect(() => {
        setSelectedAnswer(null);
        setIsLocked(false);
    }, [props.question.id]);

    const sendResult = (answer) => {
        //save result
        props.setResults((prevState) => [
            { id: props.question.id, answer: answer },
            ...prevState
        ]);

        props.setNumber((prevState) => prevState + 1);
    };

    const handlePress = (answer) => {
        if (isLocked) return; // جلوگیری از کلیک چندباره

        setIsLocked(true); // قفل کردن دکمه‌ها
        setSelectedAnswer(answer); // نمایش رنگ درست/غلط

        // تاخیر 500 میلی ثانیه‌ای (نیم ثانیه) قبل از ارسال پاسخ
        setTimeout(() => {
            sendResult(answer);
        }, 500);
    };

    // تابعی برای تعیین استایل هر دکمه
    const getButtonStyle = (optionNumber) => {
        // اگر کاربر هنوز چیزی انتخاب نکرده، استایل عادی
        if (!selectedAnswer) {
            return styles.button;
        }

        const isCorrect = props.question.correct == optionNumber;
        const isSelected = selectedAnswer == optionNumber;

        // اگر این گزینه انتخاب شده و درست است -> سبز
        if (isSelected && isCorrect) {
            return styles.buttons;
        }

        // اگر این گزینه انتخاب شده و غلط است -> قرمز
        if (isSelected && !isCorrect) {
            return styles.buttonWrong;
        }

        // اگر کاربر جواب غلط داده، جواب درست را هم سبز کنیم
        if (!isSelected && isCorrect) {
            return styles.buttons;
        }

        // برای بقیه دکمه‌ها استایل عادی
        return styles.button;
    };

    // لیست گزینه‌ها برای جلوگیری از تکرار کد
    const options = [
        { text: props.question.s1, value: 1 },
        { text: props.question.s2, value: 2 },
        { text: props.question.s3, value: 3 },
        { text: props.question.s4, value: 4 }
    ].filter(opt => opt.text); // فقط گزینه‌هایی که متن دارند نمایش داده شوند

    return (
        <View style={styles.container}>
            <Video
                style={styles.video}
                source={{
                    uri: `${Config.dl}/${props.question.url}`,
                }}
                useNativeControls
                resizeMode="contain"
                shouldPlay={true}
                isLooping={true}
            />

            <Text style={styles.text}>
                {props.question.ask}
            </Text>

            {options.map((opt) => (
                <TouchableOpacity
                    key={opt.value}
                    style={getButtonStyle(opt.value)}
                    onPress={() => handlePress(opt.value)}
                    disabled={isLocked} // دکمه‌ها بعد از کلیک غیرفعال شوند
                >
                    <Text style={styles.label}>
                        {opt.text}
                    </Text>
                </TouchableOpacity>
            ))}
        </View>
    );
};

const styles = StyleSheet.create({
    video: {
        width: '100%',
        height: RFValue(200),
        borderRadius: RFValue(15),
        marginLeft: RFValue(10),
        backgroundColor: 'black',
        borderColor: Config.maincolor,
        borderWidth: 1,
        marginBottom: RFValue(20),
    },

    button: {
        marginVertical: RFValue(4),
        backgroundColor: 'white',
        borderRadius: RFValue(20),
        borderWidth: 1,
        borderColor: '#E7E9F2',
        padding: RFValue(20),
        justifyContent: 'center',
        alignItems: 'center',
    },
    buttons: {
        marginVertical: RFValue(4),
        backgroundColor: '#E9FFE0',
        borderRadius: RFValue(20),
        borderWidth: 1,
        borderColor: '#33B300',
        padding: RFValue(20),
        justifyContent: 'center',
        alignItems: 'center',
    },
    // استایل جدید برای زمانی که کاربر جواب غلط می‌دهد
    buttonWrong: {
        marginVertical: RFValue(4),
        backgroundColor: '#FFE0E0',
        borderRadius: RFValue(20),
        borderWidth: 1,
        borderColor: '#B30000',
        padding: RFValue(20),
        justifyContent: 'center',
        alignItems: 'center',
    },

    label: {
        fontSize: RFValue(15),
        fontFamily: 'yk',
        color: Config.maincolor,
        textAlign: 'center',
    },

    text: {
        fontSize: RFValue(14),
        fontFamily: 'ykb',
        color: Config.maincolor,
        marginBottom: RFValue(20),
    },
    container: {
        flex: 1,
    },
    image: {
        marginBottom: RFValue(20),
        width: '100%',
        height: RFValue(180),
        borderRadius: RFValue(15),
    },
});

export default Examvideo;